import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'timeAmPm'
})
@Injectable({
  providedIn: 'root'
})

export class TimeOnlyPipePipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    // supports "HH:mm" or "HH:mm:ss"
    const [h, m] = value.split(':').map(Number);

    const hour12 = h % 12 || 12;
    const period = h < 12 ? 'AM' : 'PM';

    return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
  }
}
